import { render } from "./AddPurchaseRequest.vue?vue&type=template&id=cc6fb380&scoped=true"
import script from "./AddPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./AddPurchaseRequest.vue?vue&type=script&lang=js"

import "./AddPurchaseRequest.vue?vue&type=style&index=0&id=cc6fb380&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc6fb380"]])

export default __exports__